import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Master.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaEdit } from "react-icons/fa";
import { AddVendorEntity, VendorEntity } from "../../entities/VendorEntity";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";
import PopupPilih from "../../components/Popup/PopupPilih";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { VendorService } from "../../services/vendors";
import { format } from "date-fns";

export default function MasterVendor() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //
  // const [excludeFilter, setExcludeFilter] = useState();
  // const [tableDataFilter, setTableDataFilter] = useState({});

  const [tableData, setTableData] = useState<VendorEntity[]>([]);

  const [selectedVendor, setSelectedVendor] = useState<VendorEntity | null>(null);
  const [selectedAddVendor, setSelectedAddVendor] = useState<AddVendorEntity | null>(null);

  const [showPopup, setShowPopup] = useState(false);
  const [showPopupPilih, setShowPopupPilih] = useState(false);

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleAddNew = () => {
    setSelectedAddVendor(null);
    setSelectedVendor(null);
    setShowPopup(true);
  }

  const handlePopupDetail = (row: VendorEntity) => {
    setSelectedVendor(row);
    setShowPopup(true)
  }

  const handleSaveAddVendor = async () => {
    contextShowLoadingFunc(true);
    try {
      if (selectedAddVendor == null || selectedAddVendor.nama == null || selectedAddVendor.deskripsi == null) {
        throw new Error("invalid data")
      }
      const resp = await VendorService.AddVendor({ nama: selectedAddVendor.nama, deskripsi: selectedAddVendor.deskripsi });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedVendor(null);
      setSelectedAddVendor(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleSaveUpdateVendor = async () => {
    contextShowLoadingFunc(true);
    try {
      if (selectedVendor == null) { throw new Error("invalid selected vendor") }
      const resp = await VendorService.UpdateVendor(selectedVendor, { nama: selectedVendor.nama, deskripsi: selectedVendor.deskripsi });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedVendor(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleDeleteVendor = async () => {
    return contextShowAlertFunc(new AlertEntity({
      message: `Apakah anda yakin ingin menghapus ${selectedVendor?.nama} ?`,
      onOk: async () => {
        contextShowLoadingFunc(true);
        try {
          if (selectedVendor == null) { throw new Error("invalid selected vendor") }
          const resp = await VendorService.DeleteVendor(selectedVendor);
          await generateData();
          contextShowLoadingFunc(false);
          setSelectedVendor(null);
          setShowPopup(false);
          contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
          contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
          contextShowLoadingFunc(false);
        }
      },
      withCancel: true,
      withOk: true,
      level: 2
    }))
  }

  const handleGenerateExcel = async () => {
    if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
    const column = ["nama", "deskripsi"];
    let values: { [key: string]: string }[] = [];
    for (let i = 0; i < tableData.length; i++) {
      values.push({
        nama: tableData[i].nama,
        deskripsi: tableData[i].deskripsi ?? '',
      })
    }
    ExcelUtils.export(`Vendor List on ${format(new Date(), "yyyy-MM-dd")}`, column, values);
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await VendorService.GetAllVendor();
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Master Vendor"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                <div>
                  <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                  <button className="cardButton" onClick={() => handleAddNew()} >
                    Add New
                  </button>
                </div>
                <div>
                  <button className="cardButton" onClick={() => handleGenerateExcel()} >
                    Generate Excel
                  </button>
                </div>
              </div>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
              </div>
            </>
          }
        />
        <div
          style={{
            height: "65vh",
            overflow: "auto"
          }}>
          <table className="tableclickcell">
            {tableData.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama Vendor</th>
                    <th>Deskripsi</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, idx) => {
                    return <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{row.nama}</td>
                      <td>{row.deskripsi}</td>
                      <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /> Edit</td>
                    </tr>
                  })}
                </tbody>
              </>
              :
              <>
                <thead><tr><th>no data available yet!</th></tr></thead>
              </>
            }
          </table>
        </div>

        {/* Popup Detail */}
        <Popup
          setShowPopup={setShowPopup}
          showPopup={showPopup}
          popupTitle={selectedVendor == null ? "Add New" : `Edit ${selectedVendor?.nama}`}
          popupContent={
            selectedVendor == null ?
              <>
                <div className={css.form}>
                  <div className={css.containerleftright}>
                    <div className={css.leftposition}>
                      <div className={css.label}> Nama Vendor <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedAddVendor?.nama ?? ""}
                        onChange={(event) => {
                          setSelectedAddVendor((prevState: AddVendorEntity | null) => {
                            return new AddVendorEntity({
                              ...prevState,
                              nama: event.target.value
                            })
                          });
                        }}
                      />
                      <div className={css.label}> Deskripsi <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedAddVendor?.deskripsi ?? ""}
                        onChange={(event) => {
                          setSelectedAddVendor((prevState: AddVendorEntity | null) => {
                            return new AddVendorEntity({
                              ...prevState,
                              deskripsi: event.target.value
                            })
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className={css.buttons2}>
                    <div className={css.left}>
                      <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                        Close
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="primaryButton"
                        onClick={() => { handleSaveAddVendor() }} >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </>
              : <>
                <div className={css.form}>
                  <div className={css.containerleftright}>
                    <div className={css.leftposition}>
                      <div className={css.label}> Nama Vendor <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedVendor?.nama ?? ""}
                        onChange={(event) => {
                          setSelectedVendor((prevState: VendorEntity | null) => {
                            if (prevState == null) {
                              return null;
                            } else {
                              return new VendorEntity({
                                ...prevState,
                                nama: event.target.value
                              })
                            }
                          });
                        }}
                      />
                      <div className={css.label}> Deskripsi <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedVendor?.deskripsi ?? ""}
                        onChange={(event) => {
                          setSelectedVendor((prevState: VendorEntity | null) => {
                            if (prevState == null) {
                              return null;
                            } else {
                              return new VendorEntity({
                                ...prevState,
                                deskripsi: event.target.value
                              })
                            }
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className={css.buttons2}>
                    <div className={css.left}>
                      <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                        Close
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="secondaryButton" onClick={() => handleDeleteVendor()}>
                        Delete
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="primaryButton"
                        onClick={() => { handleSaveUpdateVendor() }} >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </>
          }
        />
      </div>
    </>
  );
}
